import { combineReducers } from 'redux';
// redux-form reducer
// ===============================================
// import { reducer as form } from 'redux-form';
import { reducer as formReducer } from 'redux-form';
// ===============================================
import auth  from './auth';
import cases from './cases';
import contactDetails from './contactDetails';
import createRelocation from './createRelocation';
import relocationPlanServiceDetails from './relocation/relocationPlanServiceDetails';
import relocationDCA from './relocation/relocationDCA';
import submitNotice from './submitNotice';
import relocation from './relocation/relocation';
import InternationalRelocation from './InternationalRelocation';
import petDetails from './relocation/relocationPet'
//import Qas from './qas';
import inventory from './inventory';
import relocationTravel from './relocation/relocationTravel';
import relocationPersonalDetails from './relocation/relocationPersonalDetails';
import relocationDetails from './relocation/relocationDetails';
import relocationInventoryDetails from './relocation/relocationInventoryDetails'
import referenceDataService from './referenceDataService';
import relocationHousing  from './relocation/relocationHousing';
import relocationRequest from './relocation/relocationRequest';
import dependentStreetAddressStore from './dependentStreetAddressStore'
export default combineReducers ({
    createRelocation,
    auth,
    form: formReducer,
    contactDetails,
    cases,
    dependentStreetAddressStore,
    relocationPlanServiceDetails,
    InternationalRelocation,
    relocation,
    petDetails,
    //PreAFR,
    //Qas,
    inventory,
    submitNotice,
    relocationTravel,
    relocationPersonalDetails,
    relocationDetails,
    relocationInventoryDetails,
    referenceDataService,
    relocationHousing,
    relocationRequest,
    relocationDCA
});